/** 
 *   购物车
 */
import { get } from '@/untils/js/axios.js'

// 为你推荐商品列表显示
export const getCartRemGoodsList = params => get('/goods/recommend/cart', params)